import React, { Component } from 'react';
import Tela from '../../components/telaInteira/Tela';
import Tela2 from '../../components/telaInteira2/Tela2';
import A1 from '../../components/CampoDeRuido/A1/A1';
import A2 from '../../components/CampoDeRuido/A2/A2';
import A3 from '../../components/CampoDeRuido/A3/A3';
import A4 from '../../components/CampoDeRuido/A4/A4';
import A5 from '../../components/CampoDeRuido/A5/A5';
import A6 from '../../components/CampoDeRuido/A6/A6';
import EstruturaI1 from '../../components/EstruturaInicial/EstruturaInicial';


class Inicio extends Component {
    render() {
        return (
            <div>

                <Tela>

                
                <A1>
                 <A2>
                     <A3>
                     
                         <A5>
                         <A4>
                             <A6>
                         <EstruturaI1>
                        </EstruturaI1>
                        </A6>
                        </A4>
                        </A5>
                    </A3>
                 </A2>
                </A1>
                
            </Tela>
        </div>
        )
    }
}

export default Inicio;